import React from "react";
import { useLanguage } from "../i18n";
import { PageHero, PillButton, Reveal, SectionTitle } from "../components/Shared";

const Sectors = () => {
  const { t, data } = useLanguage();

  return (
    <div data-testid="sectors-page">
      <PageHero
        title={t.sectorsPage.title}
        subtitle={t.sectorsPage.subtitle}
        image="https://images.unsplash.com/photo-1534237710431-e2fc698436d0?w=1920&q=80"
      />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal>
            <SectionTitle>{t.sectorsPage.sectionTitle}</SectionTitle>
            <p className="text-center text-slate-500 font-light -mt-6 mb-14 max-w-2xl mx-auto">
              {t.sectorsPage.sectionText}
            </p>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {data.sectors.map((sec, i) => (
              <Reveal key={sec.id} delay={(i % 3) * 110}>
                <div
                  className="group bg-white rounded-lg overflow-hidden border border-slate-200 hover:border-transparent hover:shadow-xl transition-all duration-500 h-full flex flex-col"
                  data-testid={`sector-card-${sec.id}`}
                >
                  <div className="relative overflow-hidden h-52">
                    <img
                      src={sec.image}
                      alt={sec.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#141d43]/70 via-transparent to-transparent" />
                    <h3 className="absolute bottom-4 left-5 right-5 text-white text-lg font-semibold tracking-wide">
                      {sec.title}
                    </h3>
                  </div>
                  <p className="p-7 text-slate-600 text-[14.5px] leading-relaxed font-light flex-1">{sec.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#f5f7fb] py-20">
        <div className="max-w-4xl mx-auto px-5 text-center">
          <Reveal>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#1b2653] leading-snug">{t.sectorsPage.ctaTitle}</h2>
            <p className="text-slate-600 font-light mt-4">{t.sectorsPage.ctaText}</p>
            <div className="mt-9">
              <PillButton to="/contact" dark>{t.contactUs}</PillButton>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Sectors;
